import { Component } from 'preact';
import { filterList, clearSearch } from '../../controllers/select-ifsc';
import { locale } from '../../utils/i18n';
import { staticPath } from '../../utils/common';
import NotFound from '../nb/notFound';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      listData: props.list
    };
    this.contentArea = '';
  }

  filterListData = e => {
    const stateData = filterList(e.target.value, this.props.list);
    this.setState(stateData);
  };

  clearSearchData = () => {
    const stateData = clearSearch(this.props.list);
    this.setState(stateData);
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ searchValue: '', listData: nextProps.list });
    if (this.props.heading !== nextProps.heading) {
      this.contentArea.scrollTop = 0;
    }
  }

  render({ heading, backButtonFn, placeholder, selectListData }, { searchValue, listData }) {
    return (
      <div className="ptm-content-section">
        <div className="ptm-content-top cont-top-global">
          <h2>{heading}</h2>
          <div className={`ptm-close-wrap ptm-pos-a ptm-closeIcon`} onClick={backButtonFn}>
            <span className={`ptm-cross ptm-pos-r`} />
          </div>
          <div
            className={`ptm-ib ptm-w100-ib ptm-pos-r ptm-search-field ptm-nb-boxinput ptm-pos-r`}
          >
            <input
              type="text "
              placeholder={locale(`bm.search.${placeholder}`)}
              className={`ptm-margin0 ptm-dropdown-input ptm-input-common`}
              value={searchValue}
              onKeyUp={this.filterListData}
              ref={inp => {
                this.search = inp;
              }}
            />
            <img
              className={`ptm-search-img ptm-pos-a`}
              src={`${staticPath()}/assets/images/search-icon.svg`}
              alt=""
            />
            {searchValue && (
              <div
                className={`ptm-clear-wrap ptm-closeIcon `}
                onClick={() => this.clearSearchData()}
              >
                <span className={`ptm-cross ptm-pos-r`} />
              </div>
            )}
          </div>
        </div>
        <div className={`ptm-content-mid ptm-pos-r`} ref={ele => (this.contentArea = ele)}>
          {listData.length === 0 && <NotFound />}
          <section className="ptm-bank-result">
            {!!listData.length && (
              <ul className={`bsl bsl-global`}>
                {listData.map(item => {
                  return (
                    <li
                      className={`ptm-pos-r ptm-w100-ib ptm-bank-result-list ptm-border-global`}
                      onClick={() => selectListData(item)}
                    >
                      <label for="" class="ptm-ib ptm-vm overflow-h">
                        <span className="fs14 c1">{item.displayName}</span>
                      </label>
                    </li>
                  );
                })}
              </ul>
            )}
          </section>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/select-ifsc/list.js